import { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import Header from "./Header";
import AccountDetails from "./AccountDetails";
import AddKnowledgebase from "./AddKnowledgebase";
import Uploading from "./Uploading";
import StoredDocuments from "./StoredDocuments";

import { useNavigate } from "react-router-dom";

import { Http } from "../../utils";
import { useLocation, useParams } from "react-router-dom";

import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";

import CreateFolderModal from "./CreateFolderModal";

import "./styles.css";
import images from "../../global-styles/images";
import Joyride, { ACTIONS, STATUS } from "react-joyride";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const KnowledgebaseSettings = () => {
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const { productId, versionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [tab] = useState(0);
  const [product, setProduct] = useState({});
  const [fileUploading, setFileUploading] = useState({
    uploading: false,
    name: "",
    percentage: 0,
  });
  const [storedDocuments, setStoredDocuments] = useState([]);
  const [createFolderModal, setCreateFolderModal] = useState<boolean>(false);

  const [search, setSearch] = useState("");
  const [searchDocuments, setSearchProducts] = useState([] as any);

  const [loading, setLoading] = useState(false);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [run, setRun] = useState(false);
  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = [...searchDocuments];
      const filteredRows: any = temp?.filter((row: { name: string }) => {
        return row.name.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setStoredDocuments(filteredRows);
    } else {
      setStoredDocuments(searchDocuments);
    }
  };

  const handleClearSearch = () => {
    setSearch("");
    setStoredDocuments(searchDocuments);
  };

  const handleCompareModifiedDesc = (a: any, b: any) => {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  };

  const handleOpenCreateFolderModal = () => {
    setCreateFolderModal(true);
  };

  const handleCloseCreateFolderModal = () => {
    setCreateFolderModal(false);
  };

  const handleCancelButton = () => {
    if (productId) {
      // setChatbotSettings(chatbotSettingsInitialValues);
      navigate("/add-account", {
        state: {
          id: productId,
          version: versionId,
        },
      });
    } else {
      navigate(-1);
    }
  };

  const handleFetchStoredDocuments = async () => {
    setLoading(true);
    try {
      const res: any = await Http.get({
        url: `/api/v2/kbArticles/${productId}/${versionId}`,
      });

      if (res?.kbArticles) {
        const grouped = [
          ...new Set(
            res?.kbArticles
              ?.sort(handleCompareModifiedDesc)
              .map((item: any) => item.id)
          ),
        ];

        let newFolderArray: any = [];

        if (grouped && grouped.length) {
          grouped.forEach((v, i) => {
            const respArray = res?.kbArticles;

            const sortArr = respArray.sort(handleCompareModifiedDesc);
            const sortedFolders = respArray.filter(
              (article: any) => article.type === "folder"
            );
            const childrenFiles = respArray.filter(
              (article: any) => article.type !== "folder"
            );

            newFolderArray = sortedFolders.map((folder: any) => {
              const newFolder = {
                name: folder.name,
                id: folder.id,
                fields: childrenFiles.filter(
                  (file: any) => file.folder === folder.id
                ),
              };

              return newFolder;
            });
          });
        }

        setStoredDocuments(newFolderArray);
        setSearchProducts(newFolderArray);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleRetrainDocuments = async (id: string) => {
    try {
      const res: any = await Http.post({
        url: `/api/v2/kbArticles/retrain`,
        state: userInfo,
        body: {
          productId: productId,
          productVersion: versionId,
          id: id,
        },
      });

      if (res) {
        handleFetchStoredDocuments();
      }
    } catch (err) {}
  };

  const handleDeleteDocument = async (id: string) => {
    try {
      await Http.deleteReq({
        url: `/api/v2/kbArticles/${id}`,
        state: userInfo,
      });

      handleFetchStoredDocuments();
    } catch (err) {}
  };

  const handleImportWebsite = async (values: any) => {
    try {
      const res: any = await Http.post({
        url: `/api/v2/kbArticles/url`,
        state: userInfo,
        body: {
          productId: productId,
          productVersion: versionId,
          folderName: values.folderName,
          url: values.knowledgebaseUrl,
        },
      });

      if (res) {
        handleFetchStoredDocuments();
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (location?.state?.product) {
      setProduct(location?.state?.product);
    }
  }, [location]);

  useEffect(() => {
    handleFetchStoredDocuments();
  }, []);
  const openGuidedtour = () => {
    // const element: any = document.getElementById("test-in");
    // element.scrollTop = element.scrollHeight;
    setRun(!run);
  };
  const handleJoyrideCallback = (data: any) => {
    const { action, index, status, type } = data;
    localStorage.setItem("setWalkthroughStepIndex", index);

    if (
      status == STATUS.FINISHED ||
      action == ACTIONS.CLOSE ||
      action == ACTIONS.SKIP
    ) {
      if (ACTIONS.SKIP == "skip") {
        setTooltipIsOpen(true);
        setTimeout(() => {
          setTooltipIsOpen(false);
        }, 3000);
      }
      setRun(false);
      localStorage.removeItem("setWalkthroughStepIndex");
    }
  };
  const renderGuidedSteps = () => {
    //edit form steps
    const steps = [
      {
        disableBeacon: true,
        target: ".guideTourKBCreateFolder",
        content: (
          <div>
            <h3 className="guidesteptitle">Create Folder</h3>
            <h4 className="guidestepsubtitle">
              Step 1: Folder is used to group different types of knowledge bases
              together. Create a folder first before uploading knowledge bases
              into each folder.
            </h4>
          </div>
        ),
      },
      {
        target: ".guideTourKBActions",
        content: (
          <div>
            <h3 className="guidesteptitle">Actions</h3>
            <h4 className="guidestepsubtitle">
              Step 2: Click any of these buttons to upload knowledge base
              articles either from your knowledge base website or from your file
              system.
            </h4>
          </div>
        ),
      },
      {
        target: ".guideTourKBRefreshKnwldge",
        content: (
          <div>
            <h3 className="guidesteptitle">Refresh Knowledge Base</h3>
            <h4 className="guidestepsubtitle">
              Step 3: Uploading knowledge base and training the bot takes time.
              Click the Refresh knowledge base button to know the status of your
              upload process.
            </h4>
          </div>
        ),
      },
    ];
    return steps;
  };
  return (
    <Grid
      item
      xs={12}
      className="add-form-wrap"
      sx={{
        marginRight: "40px",
      }}
    >
      <Joyride
        locale={{
          open: "Click to see the steps",
        }}
        run={run}
        callback={handleJoyrideCallback}
        // disableScrolling={true}
        styles={{
          // overlayLegacyCenter: {
          //   backgroundColor: "red",
          // },
          overlay: {
            backgroundColor: "none",
            mixBlendMode: "darken",
          },
          spotlight: {
            backgroundColor: "#fff",
            // borderRadius: 0,
            // boxShadow: "0px 0px 0px 9999px rgba(0,154,223,0.9)",
          },
          options: {
            // modal arrow and background color
            arrowColor: "#0157ff",
            backgroundColor: "#0157ff",
            // page overlay color
            overlayColor: "#4f4f4f",
            //button color
            primaryColor: "#d68520",
            //text color
            textColor: "#fff",

            //width of modal
            width: 300,
            //zindex of modal
            zIndex: 1000,
          },
        }}
        continuous
        showProgress
        showSkipButton
        steps={renderGuidedSteps()}
      />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tab}
          aria-label="tabs"
          sx={{
            padding: "0px 20px!important",
          }}
        >
          <Tab label={"Configure knowledge base"} {...a11yProps(0)} />

          <Button
            type="button"
            variant="outlined"
            sx={{ textTransform: "uppercase" }}
            className="create-pro-btn "
            id="pro-cancel"
            onClick={handleCancelButton}
          >
            Close
          </Button>
        </Tabs>
      </Box>
      <Box
        className="knowledgebase-list-container"
        sx={{
          padding: "23px 30px",
        }}
      >
        <AccountDetails
          product={product}
          handleOpenCreateFolderModal={handleOpenCreateFolderModal}
          searchDocuments={searchDocuments}
        />

        {fileUploading.uploading && <Uploading fileUploading={fileUploading} />}

        <StoredDocuments
          handleClearSearch={handleClearSearch}
          handleDeleteDocument={handleDeleteDocument}
          handleFetchStoredDocuments={handleFetchStoredDocuments}
          handleRetrainDocuments={handleRetrainDocuments}
          handleSearchTyping={handleSearchTyping}
          search={search}
          setFileUploading={setFileUploading}
          setStoredDocuments={setStoredDocuments}
          storedDocuments={storedDocuments}
          loading={loading}
        />

        {createFolderModal && (
          <CreateFolderModal
            open={createFolderModal}
            onClose={handleCloseCreateFolderModal}
            handleFetchStoredDocuments={handleFetchStoredDocuments}
          />
        )}
      </Box>

      <Button
        variant="contained"
        onClick={() => openGuidedtour()}
        className="walkthrough-btn"
      >
        <img src={images.walkthrough} /> &nbsp; Walk Through
        {/* animate-charcter */}
      </Button>
    </Grid>
  );
};

export default KnowledgebaseSettings;
